import { ICompanyData } from 'types/Company.types';

export const getInitialDetailsData = (data: ICompanyData) => {
  if (data)
    return {
      name: data?.name,
      vat_number: data?.vat_number,
      coc_number: data?.coc_number,
      phone_number: data?.phone_number,
      website: data?.website,
      email: data?.email,
    };
  else
    return {
      name: '',
      vat_number: '',
      coc_number: '',
      phone_number: '',
      website: '',
      email: '',
    };
};

export const getInitialAddressData = (data: ICompanyData) => {
  if (data)
    return {
      street: data?.address?.street || '',
      house_number: data?.address?.house_number || '',
      zip_code: data?.address?.zip_code || '',
      city: data?.address?.city || '',
      country: data?.address?.country || '',
    };
  else
    return {
      street: '',
      house_number: '',
      zip_code: '',
      city: '',
      country: '',
    };
};
